import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CashPaymentMethod from "../../../Components/Caisses/Payment/CashPaymentMethod";
import ChequePaymentMethod from "../../../Components/Caisses/Payment/ChequePaymentMethod";
import TraitePaymentMethod from "../../../Components/Caisses/Payment/TraitePaymentMethod";
import GiftCardPaymentMethod from "../../../Components/Caisses/Payment/GiftCardPaymentMethod";
import CreditCardPaymentMethod from "../../../Components/Caisses/Payment/CreditCardPaymentMethod";
import CarteSedexoPaymentMethod from "../../../Components/Caisses/Payment/CarteSedexoPaymentMethod";
import PointsFidleliteMethod from "../../../Components/Caisses/Payment keyboard/PointsFidleliteMethod";
import BonReductionMethod from "../../../Components/Caisses/Payment/BonReductionMethod";

const PAYMENT_MODES: { key: string; label: string; icon: string }[] = [
  { key: "cash", label: "Espèces", icon: "fa-money-bill-alt" },
  { key: "cheque", label: "Chèque", icon: "fa-money-check-alt" },
  { key: "traite", label: "Traite", icon: "fa-file-invoice-dollar" },
  { key: "credit card", label: "Carte bancaire", icon: "fa-credit-card" },
  { key: "carte sedexo", label: "Carte sedexo", icon: "fa-id-card" },
  { key: "gift card", label: "Ticket cadeau", icon: "fa-gift" },
  { key: "points", label: "Points fidélité", icon: "fa-wallet" },
  { key: "bon", label: "Contre bon", icon: "fa-tags" },
];

export default function Reservationpopup({
  showModal,
  setshowModal,
  t,
  listClient,
  cart,
  confirmreservation,
  givenAmout,
  dureeAvance,
  action,
  AjouterAvance,
  activePayment,
  total,
  remainingAmount,
  enteredAmountCash,
  handleEnteredAmount,
  cheques,
  updateCheque,
  addCheque,
  traites,
  updateTraite,
  addTraite,
  enteredAmountCreditCard,
  handleEnteredAmountCreditCard,
  enteredAmountCarteSedexo,
  handleEnteredAmountCarteSedexo,
  ListGiftcard,
  setListGiftcard,
  enteredAmountGiftCard,
  handleEnteredAmountGiftCard,
  fideliteAmount,
  handleEnteredAmountFidelite,
  currentClient,
}: any) {
  type clientreservationType = {
    nom: string;
    mobile: number;
    duree: number;
    date_echeance: any;
    client: any;
    _id?: any;
  };
  const [clientreservationdata, setclientreservationdata] = useState<
    clientreservationType | undefined
  >();
  const [selectedMode, setSelectedMode] = useState(activePayment || "cash");

  useEffect(() => {
    if (showModal) {
      setSelectedMode(activePayment || "cash");
    }
  }, [showModal]);

  useEffect(() => {
    if (showModal) {
      let foundclient;

      if (cart.client_id === "") {
        foundclient = cart.defaultClient;
      } else {
        foundclient = listClient.find(
          (item: any) => item._id === cart.client_id
        );
        foundclient = foundclient ? foundclient : cart.defaultClient;
      }

      if (foundclient) {
        const today = new Date();
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + 7);
        setclientreservationdata({
          _id: cart.reservation ? cart.reservation._id : undefined,
          client: cart.reservation
            ? cart.reservation.infoclient.client
            : foundclient,
          nom:'',
          mobile: cart.reservation
            ? cart.reservation.infoclient.mobile
            : !foundclient.defaultClient
            ? foundclient.mobile
            : "",
          duree: cart.reservation ? cart.reservation.duree : 7,
          date_echeance: cart.reservation
            ? cart.reservation.date_echeance.split("T")[0]
            : formatDateToInputValue(futureDate),
        });
      }
    }
  }, [listClient, cart, showModal]);

  // Only show tabs the host drawer actually supports (e.g. FloatingPaymentDrawer
  // has no traite/carte sedexo handlers).
  const availableModes = PAYMENT_MODES.filter((mode) => {
    if (mode.key === "traite") return Boolean(traites && updateTraite);
    if (mode.key === "carte sedexo")
      return Boolean(handleEnteredAmountCarteSedexo);
    return true;
  });

  const formatDateToInputValue = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const changedata = (name: string, e: any) => {
    const { value } = e.target;
    if (name === "duree") {
      const today = new Date();
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + parseInt(value) || 0);
      const newdate_echance = formatDateToInputValue(futureDate);
      setclientreservationdata((prev: any) => {
        if (prev) {
          return {
            ...prev,
            date_echeance: newdate_echance,
            duree: parseInt(value) || 0,
          };
        } else {
          return { nom: value };
        }
      });
    } else if (name === "date_echeance") {
      const date1 = new Date();
      const date2 = new Date(value);
      const differenceInTime = date2.getTime() - date1.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);
      const duree_cal = parseInt((differenceInDays + 1).toString());

      setclientreservationdata((prev: any) => {
        if (prev) {
          return {
            ...prev,
            date_echeance: value,
            duree: duree_cal,
          };
        } else {
          return { nom: value };
        }
      });
    } else {
      setclientreservationdata((prev: any) => {
        if (prev) {
          return { ...prev, [name]: value };
        } else {
          return { nom: value };
        }
      });
    }
  };

  const renderAvanceInputs = () => (
    <>
      <div className="row mt-2">
        <div
          className="col-12"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "8px",
          }}
        >
          {availableModes.map((mode) => {
            const isActive = selectedMode === mode.key;
            return (
              <button
                key={mode.key}
                type="button"
                onClick={() => setSelectedMode(mode.key)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  padding: "10px 4px",
                  minHeight: "72px",
                  borderRadius: "10px",
                  border: isActive
                    ? "1px solid #009688"
                    : "1px solid #e0e0e0",
                  background: isActive
                    ? "rgba(0, 150, 136, 0.1)"
                    : "#fff",
                  color: isActive ? "#009688" : "#515365",
                  fontWeight: isActive ? 600 : 400,
                  fontSize: "12px",
                  lineHeight: 1.2,
                  transition: "all 0.15s ease-out",
                  cursor: "pointer",
                }}
              >
                <i
                  className={`fas ${mode.icon}`}
                  style={{ fontSize: "18px" }}
                ></i>
                <span>{t(mode.label)}</span>
              </button>
            );
          })}
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          {selectedMode === "cash" && (
            <CashPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmount}
              enteredAmountCash={enteredAmountCash}
              remainingAmount={remainingAmount}
            />
          )}
          {selectedMode === "cheque" && (
            <>
              {cheques?.map((cheque: any, index: number) => (
                <ChequePaymentMethod
                  key={index}
                  index={index + 1}
                  total={total}
                  enteredAmountCheque={cheque.amount}
                  maxAmount={remainingAmount + Number(cheque.amount || 0)}
                  tel={cheque.tel}
                  setTel={(tel: any) => updateCheque(index, { ...cheque, tel })}
                  num={cheque.num_cheque}
                  setNumCheque={(num_cheque: any) =>
                    updateCheque(index, { ...cheque, num_cheque })
                  }
                  echeance={cheque.echeance}
                  setEcheance={(echeance: any) =>
                    updateCheque(index, { ...cheque, echeance })
                  }
                  onAmountChange={(amount: any) =>
                    updateCheque(index, { ...cheque, amount })
                  }
                />
              ))}
              {addCheque && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addCheque}
                  style={{ width: "100%" }}
                >
                  +
                </button>
              )}
            </>
          )}
          {selectedMode === "traite" && traites && (
            <>
              {traites.map((traite: any, index: number) => (
                <TraitePaymentMethod
                  key={index}
                  index={index + 1}
                  total={total}
                  enteredAmountTraite={traite.amount}
                  maxAmount={remainingAmount + Number(traite.amount || 0)}
                  tel={traite.tel}
                  setTel={(tel: any) => updateTraite(index, { ...traite, tel })}
                  num={traite.num_traite}
                  setNumTraite={(num_traite: any) =>
                    updateTraite(index, { ...traite, num_traite })
                  }
                  echeance={traite.echeance}
                  setEcheance={(echeance: any) =>
                    updateTraite(index, { ...traite, echeance })
                  }
                  onAmountChange={(amount: any) =>
                    updateTraite(index, { ...traite, amount })
                  }
                />
              ))}
              {addTraite && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addTraite}
                  style={{ width: "100%" }}
                >
                  +
                </button>
              )}
            </>
          )}
          {selectedMode === "credit card" && (
            <CreditCardPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmountCreditCard}
              enteredAmountCreditCard={enteredAmountCreditCard}
              maxAmount={remainingAmount + Number(enteredAmountCreditCard || 0)}
            />
          )}
          {selectedMode === "carte sedexo" && handleEnteredAmountCarteSedexo && (
            <CarteSedexoPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmountCarteSedexo}
              enteredAmountCartesedexo={enteredAmountCarteSedexo}
            />
          )}
          {selectedMode === "gift card" && (
            <GiftCardPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmountGiftCard}
              enteredAmountGiftCard={enteredAmountGiftCard}
              ListGiftcard={ListGiftcard}
              setListGiftcard={setListGiftcard}
            />
          )}
          {selectedMode === "points" && (
            <PointsFidleliteMethod
              total={total}
              onAmountChange={handleEnteredAmountFidelite}
              pointsFideliteEquivalent={fideliteAmount}
              setpointsFideliteEquivalent={handleEnteredAmountFidelite}
              currentClient={currentClient}
            />
          )}
          {selectedMode === "bon" && <BonReductionMethod cart={cart} />}
        </div>
      </div>
    </>
  );

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      animation={false}
         dialogClassName="modal-40w"

    >
      <Modal.Header closeButton>
        {" "}
        <Modal.Title className="c-primary">
          {t("Information Avance ")}
        </Modal.Title>
      </Modal.Header>
      {action === "reservation" ? (
        <Modal.Body>
          {renderAvanceInputs()}
          <div className="row mt-2">
            <strong className=" col-4">{t("Total a payer ")}</strong>
            <strong className=" col-4">{t("Avance ")}</strong>
            <strong className=" col-4">{t("Reste a payer ")}</strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-4">{cart?.totalNet?.toFixed(3)}</strong>
            <strong className=" col-4">
              {givenAmout ? Number(givenAmout).toFixed(3) : "0.000"}
            </strong>
            <strong className=" col-4">
              {(cart?.totalNet - givenAmout)?.toFixed(3)}
            </strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-12">
              {t("Nom")} {t("Prenom")}
            </strong>

            <input
              type="text "
              className="form-control col-12"
              value={clientreservationdata?.nom}
              onChange={(e) => changedata("nom", e)}
            />
          </div>

          <div className="row mt-2">
            <strong className=" col-12">{t("Numéro de téléphone")}</strong>
            <input
              type="number"
              className="form-control  numberinput col-12"
              value={clientreservationdata?.mobile}
              onChange={(e) => changedata("mobile", e)}
            />
          </div>

          <div className="row mt-2">
            <strong className=" col-12">
              {t("Durée  de reservation en jours")}
            </strong>
            <input
              type="text"
              className="form-control  numberinput col-3"
              value={clientreservationdata?.duree}
              onChange={(e) => changedata("duree", e)}
            />
          </div>
          <div className="row mt-2">
            <strong className=" col-12">{t("date d'écheance")}</strong>
            <input
              type="date"
              className="form-control"
              value={
                clientreservationdata?.date_echeance
                  ? clientreservationdata.date_echeance
                  : formatDateToInputValue(new Date())
              }
              onChange={(e) => changedata("date_echeance", e)}
            />{" "}
          </div>
        </Modal.Body>
      ) : (
        <Modal.Body>
          {renderAvanceInputs()}
          <div className="row mt-2">
            <strong className=" col-6">{t("Total a payer ")}</strong>
            <strong className=" col-6">{cart?.totalNet?.toFixed(3)}</strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-6">{t("Total avance ")}</strong>
            <strong className=" col-6">{cart?.avance?.toFixed(3)}</strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-6">{t("Reste a payer ")}</strong>
            <strong className=" col-6">
              {(
                cart?.totalNet - Number(Number(givenAmout) + cart?.avance)
              )?.toFixed(3)}
            </strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-6">{t("Avance ")}</strong>
            <strong className="col-6">
              {givenAmout ? Number(givenAmout).toFixed(3) : "0.000"}
            </strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-6">
              {t("Durée  de reservation en jours ")}
            </strong>
            <strong className="col-6">
              {" "}
              <input
                type="text "
                className="form-control "
                value={clientreservationdata?.duree}
                onChange={(e) => changedata("duree", e)}
              />{" "}
            </strong>
          </div>
          <div className="row mt-2">
            <strong className=" col-6">{t("Date d'écheance ")}</strong>
            <strong className="col-6">
              {" "}
              <input
                type="date"
                className="form-control "
                value={
                  clientreservationdata?.date_echeance
                    ? clientreservationdata.date_echeance
                    : cart.reservation.date_echeance.split("T")[0]
                }
                onChange={(e) => changedata("date_echeance", e)}
              />{" "}
            </strong>
          </div>
        </Modal.Body>
      )}

      <Modal.Footer>
        <button
          onClick={() =>
            action === "reservation"
              ? confirmreservation(cart, clientreservationdata)
              : AjouterAvance(clientreservationdata)
          }
          className="btn btn-primary-app"
        >
          {t("Valider reservation ")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
